import {ToolbarProps} from 'react-big-calendar';
import React from 'react';
import {ReactComponent as ArrayIcon} from '../../../../../../../../assets/main/groups/main-table/array.svg';
import {ReactComponent as ArrayLeftIcon} from '../../../../../../../../assets/main/groups/main-table/array-left.svg';
import {
    TimeZoneSelector
} from "components/pages/groups/group-container/students/students-pages/students-timetable/time-zones/Time-zones";
import {
    StudentsFilter
} from "components/pages/groups/group-container/students/students-pages/students-timetable/students-filter/StudentsFilter";

import {
    ReactComponent as GoogleIcon
} from '../../../../../../../../assets/main/groups/main-table/period-calendar/google.svg';
import {useAppDispatch, useAppSelector} from "common/hook";
import {useParams} from "react-router-dom";
import {fetchCalendar} from "features/model/service/calendar/calendar";
import {successGoogleCalendar} from "common/utils/calendar/calendarUtils";
import {ROLE_HR} from "entities/constants/constants";


interface CustomToolbarProps {
    setSelectedTimeZone: React.Dispatch<React.SetStateAction<string | null>>;
    label: string;
    setSendFilter: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CustomToolbar: React.FC<ToolbarProps<Event, object> & CustomToolbarProps> = (
    {
        onNavigate,
        label,
        setSelectedTimeZone,
        setSendFilter,
    }
) => {
    const dispatch = useAppDispatch()
    const {groupId} = useParams();
    const scheduleData = useAppSelector(state => state.schedule)
    const calendarData = useAppSelector(state => state.calendar)
    const roleType = useAppSelector((state) => state.role.roleType);


    const handleGoogleCalendarClick = () => {
        successGoogleCalendar();
    };


    const handleNavBlockClick = () => {
        if (groupId) {
            dispatch(fetchCalendar({groupId}));
        }
    };


    if (calendarData.authUrl && calendarData.authUrl.length > 0) {
        window.open(calendarData.authUrl, '_blank');
    }


    const goToBack = () => {
        onNavigate('PREV');
    };

    const goToNext = () => {
        onNavigate('NEXT');
    };


    return (
        <div className='toolbar-block'>
            <div className="rbc-toolbar ">
                <span className="rbc-btn-group">
                    <button type="button" onClick={goToBack}>
                        <ArrayLeftIcon/>
                    </button>
                </span>
                <span className="rbc-toolbar-label">{label}</span>
                <span className="rbc-btn-group">
                    <button type="button" onClick={goToNext}>
                        <ArrayIcon/>
                    </button>
                </span>
            </div>

            <nav className="navbar">
                <div className="navbar-right">
                    <div className="nav-block">
                        {roleType !== ROLE_HR && (
                            <button onClick={handleNavBlockClick} className="nav-block">
                                <GoogleIcon/>
                                {scheduleData.hasToken ?
                                    <span
                                        onClick={handleGoogleCalendarClick}>Синхронизировать с Google календарем</span> :
                                    <span>Авторизоваться в Google календаре</span>
                                }
                            </button>

                        )}
                        <div className="nav-block">
                            <TimeZoneSelector setSelectedTimeZone={setSelectedTimeZone}/>
                        </div>
                        <StudentsFilter setSendFilter={setSendFilter}/>
                    </div>
                </div>
            </nav>

        </div>
    );
};


// import {ToolbarProps} from 'react-big-calendar';
// import React, {useEffect} from 'react';
// import {ReactComponent as ArrayIcon} from '../../../../../../../../assets/main/groups/main-table/array.svg';
// import {ReactComponent as ArrayLeftIcon} from '../../../../../../../../assets/main/groups/main-table/array-left.svg';
// import {
//     TimeZoneSelector
// } from "components/pages/groups/group-container/students/students-pages/students-timetable/time-zones/Time-zones";
// import {
//     Filters,
//     StudentsFilter
// } from "components/pages/groups/group-container/students/students-pages/students-timetable/students-filter/StudentsFilter";
//
// import {
//     ReactComponent as GoogleIcon
// } from '../../../../../../../../assets/main/groups/main-table/period-calendar/google.svg';
//
//
//
// interface CustomToolbarProps {
//     setSelectedTimeZone: React.Dispatch<React.SetStateAction<string | null>>;
//     label: string;
//     setSendFilter: React.Dispatch<React.SetStateAction<boolean>>;
//
// }
//
// export const CustomToolbar: React.FC<ToolbarProps<Event, object> & CustomToolbarProps> = (
//     {
//         onNavigate,
//         label,
//         setSelectedTimeZone,
//         setSendFilter,
//     }
// ) => {
//
//     const handleNavBlockClick = () => {
//         const navButton = document.getElementById("navButton");
//         if (navButton) {
//             navButton.click();
//         }
//     };
//
//
//     const goToBack = () => {
//         onNavigate('PREV');
//     };
//
//     const goToNext = () => {
//         onNavigate('NEXT');
//     };
//
//
//
//     return (
//         <div className='toolbar-block'>
//             <div className="rbc-toolbar ">
//                 <span className="rbc-btn-group">
//                     <button type="button" onClick={goToBack}>
//                         <ArrayLeftIcon/>
//                     </button>
//                 </span>
//                 <span className="rbc-toolbar-label">{label}</span>
//                 <span className="rbc-btn-group">
//                     <button type="button" onClick={goToNext}>
//                         <ArrayIcon/>
//                     </button>
//                 </span>
//             </div>
//
//             <nav className="navbar">
//                 <div className="navbar-right">
//                     <div className="nav-block">
//                         <button onClick={handleNavBlockClick} className="nav-block">
//                             <GoogleIcon/>
//                             <span>Привязать к Google календарю</span>
//                         </button>
//                         <div className="nav-block">
//                             <TimeZoneSelector setSelectedTimeZone={setSelectedTimeZone}/>
//                         </div>
//                         <StudentsFilter setSendFilter={setSendFilter}/>
//                     </div>
//                 </div>
//             </nav>
//
//         </div>
//     );
// };
